module.exports = __webpack_public_path__ + "static/media/cronograma_programacion_para_ninos_.967d196d.pdf";